// export default function() {
//   ;(function() {
//     const s = document.getElementsByTagName('script')[0]
//     const b = document.createElement('script')
//     b.type = 'text/javascript'
//     b.id = 'CookieConsent'
//     b.setAttribute('data-culture', 'EN')
//     b.src = 'https://policy.app.cookieinformation.com/uc.js'
//     s.parentNode.insertBefore(b, s)
//   })()

//   console.log('Cookie Information installed')
// }

/* global CookieInformation */

export default function() {
  if (process.client) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    (function() {
      const s = document.getElementsByTagName('script')[0];
      const b = document.createElement('script');
      b.type = 'text/javascript';
      b.id = 'CookieConsent';
      b.setAttribute('data-culture', 'EN');
      b.src = 'https://policy.app.cookieinformation.com/uc.js';
      s.parentNode.insertBefore(b, s);
    })();

    console.log('Cookie Information installed');
  }
}
